import React from 'react';

const Vue_KeepAlive = () => {
  return (
    <div>
      <h1>Vue_KeepAlive Component</h1>
      <p>This is the Vue_KeepAlive tutorial page.</p>
    </div>
  );
}

export default Vue_KeepAlive;
